<template>
  <DBox
    :id="'cmp-catalog-releases-sidewindow-contract'"
    :addButton="false"
    :addLink="false"
    :addLinkLabel="$t('add_new_related_contact')"
    @add_click="onAddGenres"
  >
    <NTable
      class="dbox1"
      id="catalog-releases-sidewindow-contract"
      :config="tableConfig"
      :headers="Headers"
      :items="list"
      :showNoItems="true"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('contract')">
            <span
              @click="onContractClick(item)"
              class="ut-link ut-text-accent5"
              >{{ item["contract_name"] }}</span
            >
          </td>

          <td v-bind="tdcon('royalty_account')">
            <span
              @click="onRoyaltyAccountClick(item)"
              class="ut-link ut-text-accent5"
              >{{ item["royalty_account_name"] }}</span
            >
          </td>
          <td v-bind="tdcon('share')">
            <span>{{ item['share'] }}</span>
          </td>
          <td v-bind="tdcon('info_column')">
            <div class="ut-flex">
              <span
                class="circle-status"
                :style="{
                  backgroundColor: `#${item['label_status_colour']}`,
                }"
              ></span>
              <span
                @click.stop="(e) => onSelectContract(item)"
                class="txtov"
                :title="item['label_status_name']"
              >
                {{ item["label_status_name"] }}
              </span>
            </div>
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>
<script>
import NTable from "../../../../plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import DBox from "@dtplugins/dbox/dbox";
import { createTableHeader } from "../../../../plugins/datatable";
import {
  royaltyAccountsListLDTRoutes,
  royaltyContractsListLDTRoutes
} from "../../../royalty/router/routes";

export default {
  props: {
    selectedReleaseDetails: {
      type: Object
    }
  },
  components: {
    NTable,
    DBox
  },
  data: function() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true
      },
      releaseArtist: "",
      releaseTitle: "",
      releaseDate: "",
      releaseCode: "",
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true
      })
    };
  },
  computed: {
    Headers: function() {
      return [
        createTableHeader("contract", {mw:250,}),
        createTableHeader("royalty_account", {mw:250,}),
        createTableHeader("share", {ta:'right'}),
        createTableHeader("info_column", { text: "info" })
      ];
    },

    list: function() {
      return this.selectedReleaseDetails.l_contract_pos || [];
    }
  },

  methods: {
    onTextFieldValueChange: function() {},
    onDropdownChange: function(item, e) {
      console.log("ITEM GENRE ENK", e);
      const payload = {
        name: "genre_relation_rank",
        value: e.value,
        item: item
      };

      this.$emit("change", payload);
    },
    onDateChange: function() {},
    deleteFile: function(item) {
      const payload = { file_relation_id: item.file_relation_id };
      this.$emit("delete", payload);
      console.log("Genres", item);
    },

    onRoyaltyAccountClick: function(item) {
      console.log(item);

      this.$router.push({
        name: royaltyAccountsListLDTRoutes.names.tab,
        params: {
          royalty_account_id: item.royalty_account_id,
          tab: "overview"
        }
      });
    },
    onContractClick: function(item) {
      console.log(item);

      this.$router.push({
        name: royaltyContractsListLDTRoutes.names.tab,
        params: {
          contract_id: item.contract_id,
          tab: "overview"
        }
      });
    },

    onAddGenres: function() {
      //        this.$router.push({
      //   ...this.$route,
      //   query: {
      //     modal: "add_genre",
      //     external_id:this.selectedReleaseDetails.release.release_id
      //   },
      // });
    }
  }
};
</script>
